import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FaCheck as SaveIcon, FaWindowClose as CloseIcon } from 'react-icons/fa';

class SaveOrCancelRenderer extends PureComponent {
  static propTypes = {
    stopEditing: PropTypes.func.isRequired,
    api: PropTypes.shape({
      stopEditing: PropTypes.func.isRequired,
    }).isRequired,
  };

  editFlags = () => this.props.api.stopEditing(false);
  cancel = () => this.props.api.stopEditing(true);

  render() {
    return (
      <div className="save-or-cancel-cell">
        <button
          className="cell-icon-button"
          title="Save changes"
          onClick={this.editFlags}
        >
          <SaveIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Cancel"
          onClick={this.cancel}
        >
          <CloseIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default SaveOrCancelRenderer;
